function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isCabinetFormPinUrl } from './favoritesHelpers';

/**
 * Get current page information for creating favorites
 * @param {string} formTitle - Form title if available (optional)
 * @returns {Object} Page info object with url, title, icon, etc.
 */
export const DEFAULT_PAGE_INFO = {
  url: '/',
  title: 'File Cabinet',
  icon: 'bookmark',
  customerId: null,
  cabinet: null
};
export const parseCustomerIdFromUrl = urlString => {
  const queryIndex = urlString.indexOf('?');
  if (queryIndex === -1) {
    return null;
  }
  const match = urlString.substring(queryIndex + 1).match(/(?:^|&)customer=([^&]+)/);
  return match ? match[1] : null;
};
const getPageInfo = (formTitle = null) => {
  const browserWindow = typeof globalThis !== 'undefined' ? globalThis.window : undefined;
  if (browserWindow == null) {
    return _objectSpread({}, DEFAULT_PAGE_INFO);
  }
  let url;
  if (browserWindow.location.hash && browserWindow.location.hash !== '#/') {
    url = browserWindow.location.hash.substring(1);
  } else {
    url = browserWindow.location.pathname + browserWindow.location.search;
  }
  let contextTitle = 'Current View';
  if (url.includes('/cabinets/')) {
    const cabinetMatch = url.match(/\/cabinets\/([^/?]+)/);
    if (cabinetMatch) {
      const cabinetId = cabinetMatch[1];

      // Check if this is a form URL (has form type and ID)
      const formMatch = url.match(/\/cabinets\/[^/]+\/([^/]+)\/([^/?]+)/);
      if (formMatch) {
        const formType = formMatch[1];
        const formId = formMatch[2];

        // If form title is provided, use it; otherwise fall back to form type + ID
        if (formTitle) {
          contextTitle = formTitle;
        } else {
          // Fall back to form type + ID if form not loaded
          const formTypeName = formType.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()).trim();
          contextTitle = `${formTypeName} ${formId}`;
        }
      } else {
        const cabinetName = cabinetId.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()).trim();
        contextTitle = cabinetName;
      }
    }
  } else if (url === '/' || url === '/file-cabinet') {
    contextTitle = 'File Cabinet';
  }
  let cabinet = null;
  if (url.includes('/cabinets/')) {
    const match = url.match(/\/cabinets\/([^/?]+)/);
    if (match) {
      cabinet = match[1];
    }
  }
  const customerId = parseCustomerIdFromUrl(url);
  let icon = 'bookmark';
  if (url.includes('/cabinets/')) {
    icon = isCabinetFormPinUrl(url) ? 'thumbtack' : 'folder-open';
  }
  return {
    url,
    title: contextTitle,
    icon,
    customerId,
    cabinet
  };
};
export default getPageInfo;